import { useContext } from "react"
import { RatingContext } from "./RatingContext"

export const useRating = () => {
  return useContext(RatingContext)
}
